import { render, staticRenderFns } from "./GiftCardShareModal.vue?vue&type=template&id=2209375c&scoped=true&"
import script from "./GiftCardShareModal.vue?vue&type=script&lang=js&"
export * from "./GiftCardShareModal.vue?vue&type=script&lang=js&"
import style0 from "./GiftCardShareModal.vue?vue&type=style&index=0&id=2209375c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2209375c",
  null
  
)

export default component.exports